import React, { ComponentProps, FC } from "react";
import { styled } from "../stitches.config";
import { stitchesButtonStyles, stitchesButtonGroupStyles } from "../stitches/buttonGroup";

const StyledButtonGroup = styled("span", stitchesButtonGroupStyles);
const StyledButton = styled("button", stitchesButtonStyles);

type StitchesButtonsProps = ComponentProps<typeof StyledButtonGroup>;
type StitchesButtonProps = ComponentProps<typeof StyledButton>;

export interface ButtonGroupProps extends StitchesButtonsProps {
  buttons: (string | number)[];
  selectedIndex: number | string;
}

export const ButtonGroup: FC<ButtonGroupProps> = ({ buttons, selectedIndex, ...props }) => {
  return (
    <StyledButtonGroup {...props}>
      {buttons.map((btn, i) => (
        <Button key={i} selected={selectedIndex === buttons[i]} onClick={props.onClick}>
          {btn}
        </Button>
      ))}
    </StyledButtonGroup>
  );
};

const Button: FC<StitchesButtonProps> = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};
